import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-20/task-01";

const task: Slide = {
  title: "Please drag the schematic details of curtain wall connections in the correct order.",
  description: "Drag and drop elements.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
